<h2 mat-dialog-title class="create-title" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle><mat-icon>devices</mat-icon>Create asset</h2>
<div mat-dialog-content class="create-content">
  <p class="create-description">Add an asset and select its model and status. Required fields are marked with an asterisk.</p>
  <div class="create-presets"><span>Start with a preset</span><button mat-stroked-button type="button" (click)="defaultAsset()" [disabled]="!assetModels.length">Scout</button><button mat-stroked-button type="button" (click)="defaultHealth()" [disabled]="!assetModels.length">Health sensor</button><button mat-stroked-button type="button" (click)="defaultSensor()" [disabled]="!assetModels.length">Sensor</button></div>
  <form class="create-form" id="create-asset-form" #assetForm="ngForm" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline">
      <mat-label>Code</mat-label>
    <input matInput  type="text" required [(ngModel)]="assetPost.code" name="code">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
    <input matInput  type="text" required [(ngModel)]="assetPost.basicName" name="basicName">
    </mat-form-field>
    <mat-form-field appearance="outline" class="create-field-wide">
      <mat-label>Description</mat-label>
    <textarea matInput  required [(ngModel)]="assetPost.basicDescription" name="basicDescription"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Begin date</mat-label>
    <input matInput [matDatepicker]="picker" (dateChange)="addEvent('change', $event)"  [formControl]="date">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <!-- <textarea matInput placeholder="Begin:" required [(ngModel)]="assetPost.whenBegin" name="whenBegin"></textarea> -->
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Select Asset Model</mat-label>
    <mat-select matInput  required [(ngModel)]="assetPost.assetModelId"
        name="assetModel">
        @for (model of assetModels; track model) {
          <mat-option [value]="model.id">
            {{ model.basicName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- ngif its a scout2.2 -->
    @if (assetPost.assetModelId === '25A57B26-D5C9-4669-BDBF-C0AB80AF2635') {
      <mat-form-field appearance="outline">
        <mat-label>Modem</mat-label>
    <input matInput  type="text" required [(ngModel)]="modem" name="modem">
      </mat-form-field>
    }

    @if (assetPost.assetModelId === '25A57B26-D5C9-4669-BDBF-C0AB80AF2635') {
      <mat-form-field appearance="outline">
        <mat-label>SIM</mat-label>
    <input matInput  type="text" required [(ngModel)]="sim" name="sim">
      </mat-form-field>
    }


    <mat-form-field appearance="outline">
      <mat-label>Select Asset Status</mat-label>
    <mat-select matInput  required [(ngModel)]="assetPost.assetStatuslId"
        name="assetType">
        @for (status of assetStatus; track status) {
          <mat-option [value]="status.id">
            {{ status.basicName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

  </form>
</div>
<div mat-dialog-actions class="create-actions">
  <button mat-stroked-button type="button" (click)="onNoClick()">Cancel</button>
  <button mat-flat-button type="submit" form="create-asset-form" class="create-primary" [disabled]="!assetForm.form.valid">Create asset</button>
</div>
